import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  viewBox: "0 0 10 10",
  xmlns: "http://www.w3.org/2000/svg",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M.828 9.158a2.831 2.831 0 0 1 0-4l.49-.489a.75.75 0 0 1 1.06 1.06l-.489.49a1.325 1.325 0 0 0 0 1.876 1.358 1.358 0 0 0 1.876 0 .75.75 0 0 1 1.061 1.063 2.825 2.825 0 0 1-3.998 0Z",
      fill: "currentColor",
      stroke: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "0"
    }, null, -1),
    _createElementVNode("path", {
      d: "M7.407 5.516a.749.749 0 0 1 0-1.06l.7-.705a1.328 1.328 0 0 0 0-1.876 1.357 1.357 0 0 0-1.876 0A.75.75 0 0 1 5.174.814a2.9 2.9 0 0 1 4 0 2.831 2.831 0 0 1 0 4l-.7.7a.749.749 0 0 1-1.067.002Z",
      fill: "currentColor",
      stroke: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "0"
    }, null, -1),
    _createElementVNode("path", {
      d: "m7.177 8.72-5.5-6.5a.75.75 0 0 1 1.146-.968l5.5 6.5a.75.75 0 0 1-1.146.968Z",
      fill: "currentColor",
      stroke: "none",
      "stroke-linecap": "round",
      "stroke-linejoin": "round",
      "stroke-width": "0"
    }, null, -1)
  ])))
}
export default { render: render }